// submit_course_basic
export const SUBMIT_COURSE_BASIC = 'submit_course_basic';
export const SUBMIT_COURSE_BASIC_SUCCESSFUL = 'submit_course_basic_successfull';
export const SUBMIT_COURSE_BASIC_FAILED = 'submit_course_basic_failed';

// submit_course_pricing
export const SUBMIT_COURSE_PRICING = 'submit_course_pricing';
export const SUBMIT_COURSE_PRICING_SUCCESSFUL =
  'submit_course_pricing_successfull';
export const SUBMIT_COURSE_PRICING_FAILED = 'submit_course_pricing_failed';

// submit_course_instuictors
export const SUBMIT_COURSE_INSTUICTORS = 'submit_course_instuictors';
export const SUBMIT_COURSE_INSTUICTORS_SUCCESSFUL =
  'submit_course_instuictors_successfull';
export const SUBMIT_COURSE_INSTUICTORS_FAILED =
  'submit_course_instuictors_failed';

// reset_course_form_data
export const RESET_COURSE_FORM_DATA = 'reset_course_form_data';

// get_masterclasses
export const GET_MASTERCLASSES = 'get_masterclasses';
export const GET_MASTERCLASSES_SUCCESSFUL = 'get_masterclasses_successfull';
export const GET_MASTERCLASSES_FAILED = 'get_masterclasses_failed';

// get_course
export const GET_COURSE = 'get_course';
export const GET_COURSE_SUCCESSFUL = 'get_course_successfull';
export const GET_COURSE_FAILED = 'get_course_failed';

// Clone course
export const CLONE_COURSE = 'clone_course';
export const CLONE_COURSE_SUCCESSFUL = 'clone_course_successfull';
export const CLONE_COURSE_FAILED = 'clone_course_failed';

// delete_course
export const DELETE_COURSE = 'delete_course';
export const DELETE_COURSE_SUCCESSFUL = 'delete_course_successfull';
export const DELETE_COURSE_FAILED = 'delete_course_failed';

// get_course_students
export const GET_COURSE_STUDENTS = 'get_course_students';
export const GET_COURSE_STUDENTS_SUCCESSFUL = 'get_course_students_successfull';
export const GET_COURSE_STUDENTS_FAILED = 'get_course_students_failed';

// create_course_student
export const CREATE_COURSE_STUDENT = 'create_course_student';
export const CREATE_COURSE_STUDENT_SUCCESSFUL =
  'create_course_student_successfull';
export const CREATE_COURSE_STUDENT_FAILED = 'create_course_student_failed';

// remobve_course_student
export const REMOBVE_COURSE_STUDENT = 'remobve_course_student';
export const REMOBVE_COURSE_STUDENT_SUCCESSFUL =
  'remobve_course_student_successfull';
export const REMOBVE_COURSE_STUDENT_FAILED = 'remobve_course_student_failed';

// get_course_instructors
export const GET_COURSE_INSTRUCTORS = 'get_course_instructors';
export const GET_COURSE_INSTRUCTORS_SUCCESSFUL =
  'get_course_instructors_successfull';
export const GET_COURSE_INSTRUCTORS_FAILED = 'get_course_instructors_failed';

// add_course_instructor
export const ADD_COURSE_INSTRUCTOR = 'add_course_instructor';
export const ADD_COURSE_INSTRUCTOR_SUCCESSFUL =
  'add_course_instructor_successfull';
export const ADD_COURSE_INSTRUCTOR_FAILED = 'add_course_instructor_failed';

// remove_course_instructor
export const REMOVE_COURSE_INSTRUCTOR = 'remove_course_instructor';
export const REMOVE_COURSE_INSTRUCTOR_SUCCESSFUL =
  'remove_course_instructor_successfull';
export const REMOVE_COURSE_INSTRUCTOR_FAILED =
  'remove_course_instructor_failed';

// update_course_instructors
// export const UPDATE_COURSE_INSTRUCTORS = 'update_course_instructors';
// export const UPDATE_COURSE_INSTRUCTORS_SUCCESSFUL =
//   'update_course_instructors_successfull';
// export const UPDATE_COURSE_INSTRUCTORS_FAILED =
//   'update_course_instructors_failed';
